import { render } from "./FilterWilayahExcProv.vue?vue&type=template&id=31a7853c"
import script from "./FilterWilayahExcProv.vue?vue&type=script&lang=js"
export * from "./FilterWilayahExcProv.vue?vue&type=script&lang=js"
script.render = render

export default script